import { render, staticRenderFns } from "./StatePending.vue?vue&type=template&id=b83e4780&scoped=true&"
import script from "./StatePending.vue?vue&type=script&lang=js&"
export * from "./StatePending.vue?vue&type=script&lang=js&"
import style0 from "./StatePending.vue?vue&type=style&index=0&id=b83e4780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83e4780",
  null
  
)

export default component.exports